import { set } from 'lodash';
import {
  createAPILifecycleActions,
  createAPILifecycleActionTypes,
} from '../../../../../../redux/actions/action_utils';
import createAmplifyAPICallEpic from '../../../../../../redux/epics/utils';
import { TRIGGER_TEST_CAMPAIGN_NOTIFICATION } from '../../../../../../common/config/api_endpoints';

export const TRIGGER_TEST_CAMPAIGN_ACTION_TYPES = createAPILifecycleActionTypes(
  'TRIGGER_TEST_CAMPAIGN_ACTION_TYPES',
);
export const triggerTestCampaignAction = createAPILifecycleActions(
  TRIGGER_TEST_CAMPAIGN_ACTION_TYPES.NAME,
);

const initialState = {
  isFetching: false,
  data: null,
  error: null,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case TRIGGER_TEST_CAMPAIGN_ACTION_TYPES.BEGIN:
      return {
        ...state,
        isFetching: true,
      };
    case TRIGGER_TEST_CAMPAIGN_ACTION_TYPES.SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: payload,
        error: null,
      };
    case TRIGGER_TEST_CAMPAIGN_ACTION_TYPES.FAILURE:
      return {
        ...state,
        isFetching: false,
        data: null,
        error: payload,
      };
    case TRIGGER_TEST_CAMPAIGN_ACTION_TYPES.CLEAR:
      return initialState;
    default:
      return state;
  }
};

const payloadGenerator = async ({ originalPayload }) => {
  const newPayload = {};
  set(newPayload, ['body'], originalPayload.body);
  return newPayload;
};

const successCallback = (response, store, action) => {
  const originalPayload = action.payload;
  const { onSuccess } = originalPayload;
  if (response.status === 200 && onSuccess) {
    onSuccess(response.body);
  }
  return [triggerTestCampaignAction.SUCCESS({ ...response.body, status: response.status })];
};

export const triggerTestCampaignEpic = createAmplifyAPICallEpic({
  actionType: TRIGGER_TEST_CAMPAIGN_ACTION_TYPES.BEGIN,
  payloadGenerator,
  api: TRIGGER_TEST_CAMPAIGN_NOTIFICATION,
  successCallback,
  errorCallback: (error, store, action) => {
    const originalPayload = action.payload;
    const { onError } = originalPayload;
    if (onError) {
      onError(error);
    }
    return [triggerTestCampaignAction.FAILURE({ status: error.status || 500 })];
  },
});
